export const home = {
    labels: {
        welcome: "Welcome",
        crew_member: "Crew Member",
        create_profile: "Create Profile",
        offer_vacancy: "Offer Vacancy",
        offer_yacht: "Offer Yacht",
        see_services: "See Services",
        services: "Services",
        vacancies: "Vacancies",
        yacht_master: "Yacht Master",
    },
    texts: {
        crew_member: "We have created this exclusive space to simplify and enhance the lives of Crew Members, both newcomers and veterans, who are interested in entering and growing in the luxury super yacht industry. Here, you will find job opportunities, professional training courses, informative content, and much more with just a few clicks. Check it out now!",
        yacht_master: "Interested in listing your yacht on Brazilis?<br>Simply create a profile, tell us more about your vessel, and activate your ad. In just a few clicks, you will have access to this amazing opportunity!",
        offer_vacancy: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
    },
};
